import { render, staticRenderFns } from "./CatalogSync.vue?vue&type=template&id=1f192baf&scoped=true"
import script from "./CatalogSync.vue?vue&type=script&lang=js"
export * from "./CatalogSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f192baf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f192baf')) {
      api.createRecord('1f192baf', component.options)
    } else {
      api.reload('1f192baf', component.options)
    }
    module.hot.accept("./CatalogSync.vue?vue&type=template&id=1f192baf&scoped=true", function () {
      api.rerender('1f192baf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/catalogs/CatalogSync.vue"
export default component.exports